// extracted by mini-css-extract-plugin
export const input = "contact-module--input--ZL4Cv";
export const title = "contact-module--title--Mkl4i";
export const text = "contact-module--text--kE6hz";
export const radioWrapper = "contact-module--radioWrapper--1H21P";
export const submitB = "contact-module--submitB--1ixNk";
export const textarea = "contact-module--textarea--2BlIH";